import { type FormEvent, type ReactNode, useEffect, useState } from 'react'
import { KeyRound, ShieldCheck } from 'lucide-react'
import { api, AUTH_REQUIRED_EVENT, post } from '../api'
import { Button } from './UI'

type AuthStatus = {
  enabled: boolean
  authenticated: boolean
  session_days: number
}

export default function AuthGate({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<AuthStatus | null>(null)
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    const requireAuthentication = () => {
      if (active) setStatus(current => current ? { ...current, enabled: true, authenticated: false } : current)
    }
    window.addEventListener(AUTH_REQUIRED_EVENT, requireAuthentication)
    api<AuthStatus>('/api/auth/status')
      .then(value => { if (active) setStatus(value) })
      .catch(() => { if (active) setError('Non riesco a verificare lo stato di accesso.') })
    return () => {
      active = false
      window.removeEventListener(AUTH_REQUIRED_EVENT, requireAuthentication)
    }
  }, [])

  const login = async (event: FormEvent) => {
    event.preventDefault()
    if (!password) return
    setBusy(true)
    setError('')
    try {
      await post('/api/auth/login', { password })
      setPassword('')
      setStatus(current => current ? { ...current, authenticated: true } : current)
    } catch (reason: any) {
      setError(reason.message || 'Accesso non riuscito.')
    } finally {
      setBusy(false)
    }
  }

  if (error && !status) {
    return <main className="auth-screen"><section className="auth-card"><div className="auth-mark"><KeyRound size={24} /></div><h1>Accesso non verificabile</h1><p>{error}</p></section></main>
  }
  if (!status) return <main className="auth-screen"><div className="route-loading">Verifico l’accesso…</div></main>
  if (!status.enabled || status.authenticated) return <>{children}</>

  return <main className="auth-screen">
    <section className="auth-card">
      <div className="auth-mark"><ShieldCheck size={25} /></div>
      <span className="eyebrow">Area privata</span>
      <h1>FTSE MIB Strategy Lab</h1>
      <p>Inserisci la password per aprire il laboratorio. La sessione resta attiva per {status.session_days} giorni e non viene richiesta a ogni refresh.</p>
      <form onSubmit={login} className="auth-form">
        <div className="field"><label htmlFor="access-password">Password</label><input id="access-password" type="password" autoComplete="current-password" autoFocus value={password} onChange={event => setPassword(event.target.value)} /></div>
        {error && <div className="notice warn">{error}</div>}
        <Button type="submit" variant="primary" disabled={busy || !password}><KeyRound size={15} />{busy ? 'Verifica…' : 'Accedi'}</Button>
      </form>
    </section>
  </main>
}
